export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    // tabs
    "Home":"Home",
    "Salons":"Salons",
    "Users":"Utilisateurs",
    "Dealers":"Revendeur",
    "Digital Inventory":"Digital Inventory",
    // filtro nelle tabelle
    "Applica filtro":"Appliquer filtre",
    "filtro...":"Filtre...",
    // azioni salon
    "Crea":"Créer",
    // salons: tabella e form
    "Ragione Sociale":"Entreprise",
    "Insegna":"Enseigne",
    "Autocomplete":"Autocompléter",
    "Indirizzo":"Adresse",
    "Città":"Ville",
    "Cap":"Code postal",
    "Paese":"État",
    "Provincia":"Région",
    "Nazione":"Pays",
    "Email":"Email",
    "Telefono":"Téléphone",
    "Web":"Web",
    "Attivo":"Actif",
    "Alert":"Alerte",
    "Tipo":"Type",
    "Latitude":"Latitude",
    "Longitude":"Longitude",
    "Latitude2":"Latitude2",
    "Longitude2":"Longitude2",
    // sezioni form
    "Dati principali":"Informations primaires",
    "Sede Legale":"Adresse d'expédition",
    "Contatto":"Contact",
    "Dati qualitativi":"Informations qualitatives",
    // users: tabella e form
    "Dealer":"Dealer",
    "Codice X3":"ERP Code",
    "Nome":"Nom",
    "Cognome":"Prénom",
    "Lingua":"Langue",
    "Privilegi":"Privilèges",
    // sezioni form
    "Dati Anagrafici":"Informations anagraphiques",
    //
    "Codice Dealer":"Code du revendeur",
    "Inserire il codice":"Insérer code",
    "Codice Dealer non trovato":"Code du revendeur pas trouvé",
    // mappa
    "Mappa Saloni":"Carte des salons",
    "Saloni visualizzati:":"Salons montrées",
    "Leads":"Leads",
    "Saloni":"Salons",
    "Tipo Visualizzazione:":"Type de vue",
    "Heatmap":"Heatmap",
    "Markers":"Markers",
    "Scheda Lead":"Info lead",
    "Scheda Cliente":"Info lead",
    "Google Maps":"Google Maps",
    "Risultato ricerca:":"Résultats de la recherche",
    "Corrispondenze trovate:":"Correspondances trouvées",
    "Valutazione:":"Évaluation:",
    "Recensioni:":"Avis:",
    "x":"x",
}